export const LANGUAGES = [
  {
    _id: 'lv',
    name: 'Latviski',
    locale: 'lv_lv',
    path: ''
  },
  {
    _id: 'ru',
    name: 'Russian',
    locale: 'ru_ru',
    path: 'ru'
  },
  {
    _id: 'en',
    name: 'English',
    locale: 'en_us',
    path: 'en'
  }
]
export const CHANGE_BREAKPOINT = 'BREAKPOINT'
export const LOADING = 'LOADING'



// WEBPACK FOOTER //
// ./src/constants.js